export default "__VITE_ASSET__53157d90__"